/**
 * badge theme
 * @see https://github.com/chakra-ui/chakra-ui/blob/%40chakra-ui/react%403.0.0/packages/react/src/theme/recipes/badge.ts
 */
import { defineRecipe } from '@chakra-ui/react';
export const badge = defineRecipe({
    base: {
        textTransform: 'uppercase',
    },
    variants: {
        variant: {
            tier: {
                bg: 'secondary.orange',
                color: 'black',
                rounded: '4px',
                px: '2',
            },
            'tier-disabled': {
                bg: 'transparent',
                color: 'state.disabled',
                border: `2px solid {colors.state.disabled}`,
                rounded: '4px',
                px: '2',
            },
            outline: {
                minW: '44px',
                shadow: 'unset',
                borderWidth: '2px',
                color: 'text.default',
                borderColor: 'currentcolor',
                justifyContent: 'center',
                px: '8px',
            },
        },
        size: {
            md: {
                textStyle: 'overline',
                minH: '20px',
            },
        },
    },
    compoundVariants: [],
    defaultVariants: {
        size: 'md',
        variant: 'outline',
    },
});
